import { useState } from 'react'
import { useConfigureProfile } from '@/hooks/useProviderConfiguration'
import Button from '@/components/common/Button/Button'
import Input from '@/components/forms/Input/Input'
import './ProviderConfigureProfile.css'

const ProviderConfigureProfile = () => {
    const configure = useConfigureProfile()
    const [lat, setLat] = useState('')
    const [lng, setLng] = useState('')
    const [radius, setRadius] = useState('')

    const handleSave = async () => {
        if (!lat || !lng || !radius) return
        await configure.mutateAsync({
            service_location_latitude: Number(lat),
            service_location_longitude: Number(lng),
            service_radius_km: Number(radius),
        })
    }

    return (
        <div className="provider-configure-page">
            <div className="provider-configure-container">
                <h1 className="provider-configure-title">Configurar Perfil</h1>
                <div className="provider-configure-form">
                    <Input name="lat" placeholder="Latitud" value={lat} setValue={setLat} effect3d={false} />
                    <Input name="lng" placeholder="Longitud" value={lng} setValue={setLng} effect3d={false} />
                    <Input name="radius" placeholder="Radio (km)" value={radius} setValue={setRadius} effect3d={false} />
                    <Button variant="primary" onClick={handleSave} disabled={configure.isPending || !lat || !lng || !radius} effect3d={false}>Guardar</Button>
                </div>
            </div>
        </div>
    )
}

export default ProviderConfigureProfile


